webpackJsonp([266278358803734],{

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/beamcolumnjoint.076ad955.png";

/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo.45184a2a.png";

/***/ }),

/***/ 185:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/update_plots.7467c845.png";

/***/ }),

/***/ 440:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  background-image: url(', ');\n  background-size: 100%;\n  @media (min-width: 300px) {\n    background-position: center;\n    background-repeat: no-repeat;\n    height: 450px;\n  }\n'], ['\n  background-image: url(', ');\n  background-size: 100%;\n  @media (min-width: 300px) {\n    background-position: center;\n    background-repeat: no-repeat;\n    height: 450px;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n\tposition: fixed;\n\tzIndex: 999;\n\tbackground-image: url(', ');\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n  @media (max-width: 299px) {\n    right: 10%;\n    bottom: 0%;\n    width: 20%;\n    height: 20%;\n  }\n  @media (min-width: 300px) {\n    right: 10%;\n    bottom: 0%;\n    width: 15%;\n    height: 15%;\n  }\n  @media (min-width: 600px) {\n    right: 7%;\n    bottom: 2%;\n    width: 12%;\n    height: 12%;\n  }\n  @media (min-width: 1100px) {\n    right: 2%;\n\t  bottom: 2%;\n\t  width: 15%;\n\t  height: 15%;\n\t}\n\n'], ['\n\tposition: fixed;\n\tzIndex: 999;\n\tbackground-image: url(', ');\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n  @media (max-width: 299px) {\n    right: 10%;\n    bottom: 0%;\n    width: 20%;\n    height: 20%;\n  }\n  @media (min-width: 300px) {\n    right: 10%;\n    bottom: 0%;\n    width: 15%;\n    height: 15%;\n  }\n  @media (min-width: 600px) {\n    right: 7%;\n    bottom: 2%;\n    width: 12%;\n    height: 12%;\n  }\n  @media (min-width: 1100px) {\n    right: 2%;\n\t  bottom: 2%;\n\t  width: 15%;\n\t  height: 15%;\n\t}\n\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HeadlineWithFocus = __webpack_require__(9);
	
	var _HeadlineWithFocus2 = _interopRequireDefault(_HeadlineWithFocus);
	
	var _styledComponents = __webpack_require__(11);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _hedron = __webpack_require__(17);
	
	var _colorbar = __webpack_require__(16);
	
	var _colorbar2 = _interopRequireDefault(_colorbar);
	
	var _logo = __webpack_require__(184);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _beamcolumnjoint = __webpack_require__(183);
	
	var _beamcolumnjoint2 = _interopRequireDefault(_beamcolumnjoint);
	
	var _update_plots = __webpack_require__(185);
	
	var _update_plots2 = _interopRequireDefault(_update_plots);
	
	var _forcedrift = __webpack_require__(103);
	
	var _forcedrift2 = _interopRequireDefault(_forcedrift);
	
	var _hierarchy = __webpack_require__(104);
	
	var _hierarchy2 = _interopRequireDefault(_hierarchy);
	
	var _license = __webpack_require__(105);
	
	var _license2 = _interopRequireDefault(_license);
	
	var _index = __webpack_require__(60);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _download = __webpack_require__(35);
	
	var _download2 = _interopRequireDefault(_download);
	
	var _reactScrollableAnchor = __webpack_require__(23);
	
	var _reactScrollableAnchor2 = _interopRequireDefault(_reactScrollableAnchor);
	
	var _reactResponsiveEmbed = __webpack_require__(33);
	
	var _reactResponsiveEmbed2 = _interopRequireDefault(_reactResponsiveEmbed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ImageWrapper = _styledComponents2.default.div.attrs({
	
			image: function image(props) {
					return props.image;
			}
	})(_templateObject, function (props) {
			return props.image;
	});
	
	var DownloadIconContainer = _styledComponents2.default.div(_templateObject2, _download2.default);
	
	var ImgColStyle = {
			padding: '0'
	};
	
	var RowStyleEVEN = {
			background: '#F9F9F9'
	};
	
	var RowStyleODD = {
			background: '#F5F5F5'
	};
	
	var About = function About(props) {
			return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
							'a',
							{ href: '#download' },
							_react2.default.createElement(DownloadIconContainer, null)
					),
					_react2.default.createElement(
							_hedron.Row,
							{ alignItems: 'center', style: RowStyleEVEN },
							_react2.default.createElement(
									_hedron.Column,
									{ xs: 12, sm: 12, smShift: 0, md: 6, lg: 4, style: ImgColStyle },
									_react2.default.createElement(ImageWrapper, { image: _logo2.default })
							),
							_react2.default.createElement(
									_hedron.Column,
									{ xs: 12, sm: 12, smShift: 0, md: 6, lg: 8 },
									_react2.default.createElement(
											'h1',
											null,
											_react2.default.createElement(
													'u',
													{ style: { textDecoration: 'none', borderBottom: '10px solid #DFAB50' } },
													'Beam Column Joint'
											)
									),
									_react2.default.createElement(
											'h3',
											null,
											_react2.default.createElement(
													'p',
													null,
													'Gerarchia delle resistenze per un subassemblaggio nodo, trave, colonna. Il risultato \xE8 rappresentato in un performance domain, considerando flessione, taglio, instabilit\xE0 delle barre e collasso per sfilamento'
											)
									)
							)
					),
					_react2.default.createElement(
							_hedron.Row,
							{ alignItems: 'center', style: RowStyleODD },
							_react2.default.createElement(
									_hedron.Column,
									{ xs: 12, sm: 12, smShift: 0, md: 6, lg: 4, style: ImgColStyle },
									_react2.default.createElement(ImageWrapper, { image: _beamcolumnjoint2.default })
							),
							_react2.default.createElement(
									_hedron.Column,
									{ xs: 12, sm: 12, smShift: 0, md: 6, lg: 8 },
									_react2.default.createElement(
											'h1',
											null,
											_react2.default.createElement(
													'u',
													{ style: { textDecoration: 'none', borderBottom: '12px solid #A661C2' } },
													'Standalone'
											),
											_react2.default.createElement('br', null)
									),
									_react2.default.createElement(
											'h3',
											null,
											_react2.default.createElement(
													'p',
													null,
													'Non hai bisogno di altro software per usarla'
											)
									)
							)
					),
					_react2.default.createElement(
							_hedron.Row,
							{ alignItems: 'center', style: RowStyleEVEN },
							_react2.default.createElement(
									_hedron.Column,
									{ xs: 12, sm: 12, smShift: 0, md: 6, lg: 4, style: ImgColStyle },
									_react2.default.createElement(ImageWrapper, { image: _update_plots2.default })
							),
							_react2.default.createElement(
									_hedron.Column,
									{ xs: 12, sm: 12, smShift: 0, md: 6, lg: 8 },
									_react2.default.createElement(
											'h1',
											null,
											_react2.default.createElement(
													'u',
													{ style: { textDecoration: 'none', borderBottom: '12px solid #DFAB50' } },
													'Ambiente "Type and Check"'
											)
									),
									_react2.default.createElement(
											'h3',
											null,
											_react2.default.createElement(
													'p',
													null,
													'Ogni volta che imposti un parametro un grafico permette di verificarne immediatamente la correttezza'
											)
									)
							)
					),
					_react2.default.createElement(
							_hedron.Row,
							{ alignItems: 'center', style: RowStyleODD },
							_react2.default.createElement(
									_hedron.Column,
									{ xs: 12, sm: 12, smShift: 0, md: 6, lg: 4, style: ImgColStyle },
									_react2.default.createElement(ImageWrapper, { image: _forcedrift2.default })
							),
							_react2.default.createElement(
									_hedron.Column,
									{ xs: 12, sm: 12, smShift: 0, md: 6, lg: 8 },
									_react2.default.createElement(
											'h1',
											null,
											_react2.default.createElement(
													'u',
													{ style: { textDecoration: 'none', borderBottom: '12px solid #A661C2' } },
													'Modalit\xE0 di collasso degli elementi'
											)
									),
									_react2.default.createElement(
											'h3',
											null,
											_react2.default.createElement(
													'p',
													null,
													'Uno dei risultati dell\'analisi \xE8 il meccanismo di collasso previsto per i singoli elementi: flessione, instabilit\xE0 delle barre, taglio'
											)
									)
							)
					),
					_react2.default.createElement(
							_hedron.Row,
							{ alignItems: 'center', style: RowStyleEVEN },
							_react2.default.createElement(
									_hedron.Column,
									{ xs: 12, sm: 12, smShift: 0, md: 6, lg: 4, style: ImgColStyle },
									_react2.default.createElement(ImageWrapper, { image: _hierarchy2.default })
							),
							_react2.default.createElement(
									_hedron.Column,
									{ xs: 12, sm: 12, smShift: 0, md: 6, lg: 8 },
									_react2.default.createElement(
											'h1',
											null,
											_react2.default.createElement(
													'u',
													{ style: { textDecoration: 'none', borderBottom: '12px solid #DFAB50' } },
													'Hierarchy of strength'
											)
									),
									_react2.default.createElement(
											'h3',
											null,
											_react2.default.createElement(
													'p',
													null,
													'BCJ determina la gerarchia delle resistenze del sub-assembly, indicando il meccanismo di collasso dell\'elemento che causa lo stato limite ultimo del sub-assembly stesso'
											)
									)
							)
					),
					_react2.default.createElement(
							_hedron.Row,
							{ alignItems: 'center', style: RowStyleODD },
							_react2.default.createElement(
									_hedron.Column,
									{ xs: 12, sm: 12, smShift: 0, md: 6, lg: 4, style: ImgColStyle },
									_react2.default.createElement(ImageWrapper, { image: _license2.default })
							),
							_react2.default.createElement(
									_hedron.Column,
									{ xs: 12, sm: 12, smShift: 0, md: 6, lg: 8 },
									_react2.default.createElement(
											'h1',
											null,
											_react2.default.createElement(
													'u',
													{ style: { textDecoration: 'none', borderBottom: '12px solid #A661C2' } },
													'Licenza'
											)
									),
									_react2.default.createElement(
											'h3',
											null,
											_react2.default.createElement(
													'p',
													null,
													'Licenza Creative commons \u201CAttribuzione-Non Derivati 4.0 International\u201D'
											)
									)
							)
					),
					_react2.default.createElement(
							_hedron.Row,
							{ alignItems: 'center', style: RowStyleEVEN },
							_react2.default.createElement(
									_hedron.Column,
									{ xs: 12, sm: 12, smShift: 0, md: 6, lg: 4, style: ImgColStyle },
									_react2.default.createElement(_reactResponsiveEmbed2.default, { src: 'https://www.youtube.com/embed/CFeXt9F0de0', allowFullScreen: true })
							),
							_react2.default.createElement(
									_hedron.Column,
									{ xs: 12, sm: 12, smShift: 0, md: 6, lg: 8 },
									_react2.default.createElement(
											'h1',
											null,
											_react2.default.createElement(
													'u',
													{ style: { textDecoration: 'none', borderBottom: '12px solid #DFAB50' } },
													'In azione'
											)
									),
									_react2.default.createElement(
											'h3',
											null,
											_react2.default.createElement(
													'p',
													null,
													'Guarda questo semplice tutorial'
											)
									)
							)
					),
					_react2.default.createElement(
							_hedron.Row,
							null,
							_react2.default.createElement(
									_reactScrollableAnchor2.default,
									{ id: 'download' },
									_react2.default.createElement(
											_hedron.Column,
											{ xs: 12, sm: 12, smShift: 0, md: 10, mdShift: 1, lg: 8, lgShift: 2 },
											_react2.default.createElement(_index2.default, { formName: 'bcjit' })
									)
							)
					)
			);
	};
	
	exports.default = About;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-bcj-index-it-jsx-34c801329016a9211bee.js